export default __webpack_public_path__ + "static/media/blur-544.05aaf0a5.png";